var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuclose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.05086 0.822679C1.66033 0.432154 1.02717 0.432154 0.636643 0.822679C0.246119 1.2132 0.246119 1.84637 0.636643 2.23689L5.58639 7.18664L0.636643 12.1364C0.246119 12.5269 0.246119 13.1601 0.636643 13.5506C1.02717 13.9411 1.66033 13.9411 2.05086 13.5506L7.0006 8.60085L11.9504 13.5506C12.3409 13.9411 12.974 13.9411 13.3646 13.5506C13.7551 13.1601 13.7551 12.5269 13.3646 12.1364L8.41482 7.18664L13.3646 2.23689C13.7551 1.84637 13.7551 1.2132 13.3646 0.822679C12.974 0.432154 12.3409 0.432155 11.9504 0.822679L7.0006 5.77243L2.05086 0.822679Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuclose);
export default __webpack_public_path__ + "static/media/menuclose.317c49c330f1b1018c238c00b4afb815.svg";
export { ForwardRef as ReactComponent };